module.exports = __webpack_public_path__ + "media/images/pen_orange-0ab5453a.png";